"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationDocumentDto = instanceOfOrientationDocumentDto;
exports.OrientationDocumentDtoFromJSON = OrientationDocumentDtoFromJSON;
exports.OrientationDocumentDtoFromJSONTyped = OrientationDocumentDtoFromJSONTyped;
exports.OrientationDocumentDtoToJSON = OrientationDocumentDtoToJSON;
exports.OrientationDocumentDtoToJSONTyped = OrientationDocumentDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationDocumentDto interface.
 */
function instanceOfOrientationDocumentDto(value) {
    if (!('href' in value) || value['href'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('orientationId' in value) || value['orientationId'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    return true;
}
function OrientationDocumentDtoFromJSON(json) {
    return OrientationDocumentDtoFromJSONTyped(json, false);
}
function OrientationDocumentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'href': json['href'],
        'mimeType': json['mimeType'],
        'orientationId': json['orientationId'],
        'fileName': json['fileName'],
    };
}
function OrientationDocumentDtoToJSON(json) {
    return OrientationDocumentDtoToJSONTyped(json, false);
}
function OrientationDocumentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'href': value['href'],
        'mimeType': value['mimeType'],
        'orientationId': value['orientationId'],
        'fileName': value['fileName'],
    };
}
//# sourceMappingURL=OrientationDocumentDto.js.map